export default __webpack_public_path__ + "static/media/Desligada.8befff63.svg";